import { Button, Form } from "rsuite";
import { useState } from "react";
import {
  ChangePasswordFormType,
  ChangePasswordFormSchema,
  ChangePasswordDefaultValues,
} from "../../models/forms/changePasswordForm";
import { showErrorToast, showSuccessToast } from "../generic/toast.component";
import { useNavigate } from "react-router-dom";
import { AppRoutesUI } from "../../config/appRoutes";
import { ApiAdmin } from "../../core/apis/admin";
import { ChangePasswordForm } from "../generic/forms/changePassword/changePasswordForm";
import { useAppSelector } from "../../core/redux/reduxStore";

export const ChangePasswordAdmin = () => {
  const [formValue, setFormValue] = useState<ChangePasswordFormType>(
    ChangePasswordDefaultValues
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const handleSave = async (checked: boolean) => {
    if (!checked) return;
    setIsLoading(true);
    const hasAtLeastOneCapLetter =
      /[A-Z]/.test(formValue.NewPassword ?? "") &&
      /[A-Z]/.test(formValue.confPassword ?? "");
    const hasAtLeastOneNumber =
      /[0-9]/.test(formValue.NewPassword ?? "") &&
      /[0-9]/.test(formValue.confPassword ?? "");
    if (formValue.CurrentPassword === formValue.NewPassword) {
      showErrorToast("Old Password and New Password cannot be same");
      setIsLoading(false);
      return;
    } else if (formValue.NewPassword !== formValue.confPassword) {
      showErrorToast("New Password and Confirm Password don't match");
      setIsLoading(false);
      return;
    } else if (
      (formValue.NewPassword && formValue.NewPassword?.length < 8) ||
      (formValue.confPassword && formValue.confPassword?.length < 8) ||
      !hasAtLeastOneCapLetter ||
      !hasAtLeastOneNumber
    ) {
      showErrorToast(
        "Password must be at least 8 characters (at least 1 number and 1 capital letter)"
      );
      setIsLoading(false);
      return;
    } else {
      try {
        await ApiAdmin.changePassword(
          formValue.CurrentPassword || "",
          formValue.NewPassword || " "
        );
        navigate(AppRoutesUI.Admins.AdminList());
        showSuccessToast("Password Reset Successful");
      } catch (e: any) {
        showErrorToast(e.response?.data?.Message || e.message);
      }
      setIsLoading(false);
      setFormValue(ChangePasswordDefaultValues);
    }
  };
  return (
    <div className="profile-card">
      <Form
        formValue={formValue}
        onChange={setFormValue}
        model={ChangePasswordFormSchema}
        onSubmit={handleSave}
        fluid
      >
        <ChangePasswordForm />
        <div className="d-flex justify-content-end align-items-center">
          <Button
            size="sm"
            appearance="primary"
            className="m-2 me-3 form-buttons"
            type="submit"
            loading={isLoading}
          >
            Update
          </Button>
        </div>
      </Form>
    </div>
  );
};
